export default "__VITE_ASSET__CnUpcwIF__"